import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import PropTypes from 'prop-types';
import { renderComponentField } from '../FormField';
import { DatePickerWrap } from './DatePickerElements';
import { parseISO, isValid } from 'date-fns';
import { FormGroupLabel } from '../FormElements';
import { RequiredMark } from '../BaseInput';

const toDate = val => {
  if (!val) return null;
  if (val instanceof Date) return isValid(val) ? val : null;

  if (typeof val === 'string') {
    const d = parseISO(val);
    return isValid(d) ? d : null;
  }

  if (typeof val === 'number') {
    const d = new Date(val);
    return isValid(d) ? d : null;
  }

  return null;
};

const DateTimePickerField = ({
  label,
  onChange,
  required,
  value,
  ...other
}) => {
  const [startDate, setStartDate] = useState(toDate(value)); // Atualizar o estado quando o valor externo mudar

  useEffect(() => {
    setStartDate(toDate(value));
  }, [value]);

  const handleChange = date => {
    setStartDate(date);
    onChange(date);
  };

  const handleChangeRaw = (event) => {
    const rawValue = event?.target?.value;
    if (rawValue === '') {
      setStartDate(null);
      onChange(null);
    }
  };

  return <>
    {label && <FormGroupLabel>
      {label}
      {required && <RequiredMark>*</RequiredMark>}
    </FormGroupLabel>}
    <DatePickerWrap>
      <DatePicker {...other} timeFormat="HH:mm" selected={startDate} onChange={handleChange} onChangeRaw={handleChangeRaw} type="text" showTimeSelect dateFormat="dd/MM/yyyy HH:mm" dropDownMode="select" withPortal={isMobileOnly} isClearable={true} placeholderText="Selecione data e hora" />
    </DatePickerWrap>
  </>;
};

DateTimePickerField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.number])
};
export default renderComponentField(DateTimePickerField);
